
namespace Matrix.Workflow {

    @Serenity.Decorators.registerClass()
    export class DataQualityWorkflowGrid extends SiteEntityGrid<WorkflowRow, any> {
        protected getColumnsKey() { return 'Workflow.DataQualityWorkflow'; }
        protected getDialogType() { return DataQualityWorkflowDialog; }
        protected getIdProperty() { return WorkflowRow.idProperty; }
        protected getLocalTextPrefix() { return WorkflowRow.localTextPrefix; }
        protected getService() { return WorkflowService.baseUrl; }
        protected getAddButtonCaption() { return "New Data Quality Workflow"; }
        protected getInitialTitle() { return "Data Quality Workflows"; }

        constructor(container: JQuery) {
            super(container);
        }

        protected onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[WorkflowRow.Fields.Class1] = "MX:DQ TEST RESULT";

            return true;
        }
    }
}